/* eslint-disable */
import React, {Component} from 'react'
import {message} from 'antd'
import http from '../../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'

class AddBank extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }

  addBank() {
    let bank = document.getElementById('bank').value

    let bankError = false
    let formError = false

    if (bank == '') {
      formError = true
      bankError = true
      message.error('نام بانک را وارد کنید')
    } else {
      if (!bankError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: bank
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_ADD_BANK}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('نام بانک اضافه شد')
            setInterval(() => {
              window.location.assign('/Base/payment/banks')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>اطلاعات پایه</Link>
            </li>
            <li>
              <Link to={'/Payment'}>پرداخت</Link>
            </li>
            <li>ثبت نام بانک</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت نام بانک </p>
            </div>
            <div className="formComponent">
              <label>
                نام بانک <span className="requireFiled">*</span>
              </label>
              <input type="text" id="bank" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addBank.bind(this)}>
                ثبت
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddBank
